import { useState, useEffect } from 'react';

/**
 * Returns a debounced copy of `value` that only updates after `delay`ms
 * have passed without `value` changing. Useful for search inputs so a
 * keystroke doesn't trigger a fetch on every character.
 */
export function useDebounce(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
